import * as React from 'react';
import Icon from '@material-ui/core/Icon'
import { Scrollbars }  from 'react-custom-scrollbars';
import MenuItem from './MenuItem';
import { ReactComponent as BreakBulk } from '../../Assets/images/break-bulk.svg';
import { ReactComponent as CargaAnunciada } from '../../Assets/images/carga-anunciada.svg';
import { ReactComponent as CobreAlmacenado } from '../../Assets/images/cobre-almacenado.svg';
import { ReactComponent as CobreLoteado } from '../../Assets/images/cobre-loteado.svg';
import { ReactComponent as Consolidado } from '../../Assets/images/consolidado.svg';
import { ReactComponent as Stacking } from '../../Assets/images/stacking.svg';
import { ReactComponent as Config } from '../../Assets/images/config.svg';

export interface IMenuProps {
	route: string;
	isAdmin: boolean;
}

const routes = [
	{
		icon: <Icon>home</Icon>,
		text: 'Home',
		route: '/'
	},
	{
		icon: <CargaAnunciada />,
		text: 'Carga Anunciada',
		route: '/carga-anunciada'
	},
	{
		icon: <CobreAlmacenado />,
		text: 'Cobre Almenado',
		route: '/cobre-almacenado'
	},
	{
		icon: <CobreLoteado />,
		text: 'Cobre Loteado',
		route: '/cobre-loteado'
	},
	{
		icon: <BreakBulk />,
		text: 'Embarcado Break Bulk',
		route: '/break-bulk'
	},
	{
		icon: <Consolidado />,
		text: 'Consolidado',
		route: '/consolidado'
	},
	{
		icon: <Stacking />,
		text: 'Stacking',
		route: '/stacking'
	},
	{
		icon: <Config />,
		text: 'Administración',
		route: '/administration'
	}
]

const Menu = (props: IMenuProps) => (<Scrollbars className="menu">
	{routes.filter(r => r.text !== 'Administración' || (r.text === 'Administración' && props.isAdmin)).map(r => <MenuItem key={r.route} icon={r.icon} text={r.text} route={r.route} active={r.route === "/" ? r.route === props.route :  props.route.indexOf(r.route)>=0} />)}
</Scrollbars>);

export default Menu;
